import React from 'react';
import classes from "../../ExamToPrint.module.css";

const OralHeader = () => <div className={classes.catName}>Münd.:</div>

export default OralHeader;
